export default __webpack_public_path__ + "static/media/handshake-dark.bdf84534.mp4";